
import React from 'react';
import { toast } from "sonner";
import ProgramCheckIn from '@/components/ProgramCheckIn';
import analytics from '@/utils/analytics';

interface LessonProgramCheckInProps {
  dayNumber: number;
  showProgramCheckIn: boolean;
  setShowProgramCheckIn: React.Dispatch<React.SetStateAction<boolean>>;
  setEarnedPoints: React.Dispatch<React.SetStateAction<number>>;
}

const LessonProgramCheckIn: React.FC<LessonProgramCheckInProps> = ({ 
  dayNumber, 
  showProgramCheckIn, 
  setShowProgramCheckIn, 
  setEarnedPoints 
}) => {
  if (!showProgramCheckIn) {
    return null;
  }

  const handleProgramCheckInComplete = () => {
    // After program check-in, show the regular lesson
    setShowProgramCheckIn(false);
    
    // Give bonus points for completing a program check-in
    const bonusPoints = dayNumber === 7 ? 25 : 50; // More points for final check-in
    
    // Update points without marking the day as complete yet
    setEarnedPoints(prev => prev + bonusPoints);
    toast.success(`Program check-in completed! +${bonusPoints} bonus points`);
    
    analytics.trackUserAction('program_checkin_bonus', { day: dayNumber, points: bonusPoints });
  };

  return (
    <ProgramCheckIn 
      day={dayNumber} 
      onComplete={handleProgramCheckInComplete} 
    />
  );
};

export default LessonProgramCheckIn;
